import { Box, FormControlLabel, FormGroup, Skeleton, Switch } from "@mui/material";

import { GreyPallet } from "../../../config/styles";

import MainText from "../../MainText";

type SwitchMainProps = {
  name: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  onSubmit?: () => void;
  loading?: boolean;
  disabled?: boolean;
  small?: string | JSX.Element;
  noBottom?: boolean;
};

export default function SwitchMain({
  name,
  checked,
  onChange,
  disabled,
  small,
  noBottom,
}: SwitchMainProps) {
  return (
    <FormGroup
      sx={{
        mb: noBottom ? 0 : 2,
        "& .MuiTypography-root": {
          fontWeight: "bold",
          color: GreyPallet.RegularGhost,
        },
        color: GreyPallet.Black,
        "& .MuiFormControlLabel-root": {
          justifyContent: "space-between",
          marginLeft: 0,
        },
        backgroundColor: GreyPallet.LightGhost,
        borderRadius: "15px",
        py: 1,
        px: 2,
      }}
    >
      <FormControlLabel
        labelPlacement="start"
        control={
          <Switch
            disabled={disabled}
            checked={checked}
            onChange={(e, checked) => onChange(checked)}
            color="secondary"
          />
        }
        label={name}
      />
      {small ? (
        <Box mt={1}>
          <MainText size="small" color="regular">
            {small}
          </MainText>
        </Box>
      ) : null}
    </FormGroup>
  );
}

type SwitchSkeletonProps = {
  noBottom?: boolean;
};

export function SwitchMainSkeleton({ noBottom }: SwitchSkeletonProps) {
  return (
    <Skeleton
      animation="wave"
      variant="rounded"
      width={"100%"}
      height={54}
      sx={{ borderRadius: "15px", mb: noBottom ? 0 : 2 }}
    />
  );
}
